import { Main } from './components';

const CoverageZones = () => <Main />;

export default CoverageZones;

